import React from "react";

export const OthersComponent = (props) => {
  return (
    <React.Fragment>
      <h5 className="help-text-heading5">
        <i className="text-red">Q.</i> {props.question}
      </h5>
      <p className="help-text-paragraph5">
        <i className="help-text-heading5 text-dark">A.</i> {props.answer}
      </p>
      {/* <h5 className="help-text-heading5">
        Why handicap or highchair option is not available in all the places?
      </h5>
      <p className="help-text-paragraph5">
        Handicap and Highchair request is available for those places which have
        marked themselves to provide such service. The one where the information
        is not requested may not be able to provide either Highchair or
        provision for handicap.
      </p>
      <h5 className="help-text-heading5">Why can’t I find my locality?</h5>
      <p className="help-text-paragraph5">
        While Amealio restaurants are spread all over the city, some areas may
        not have restaurants who are currently associated with Amealio These
        localities won’t be listed. We are working ‘round the clock to ensure
        that we have more restaurants on board. If you have a restaurant that
        you would like to see on Amealio please let us know through
        nomination/referral or via email - support@sminq.com
      </p> */}
    </React.Fragment>
  );
};
